import { Injectable } from "@angular/core";
import AES from 'crypto-js/aes';
import UTF8 from 'crypto-js/enc-utf8';
@Injectable({
  providedIn: "root"
})
export class EncryptionService {

  constructor() {}

  guid() {
    return "0eeb7d2f-53ed-4b57-8a77-17729b0ae7e9";
  }

  dec(text: string) {
    if (text === null || text === "") {
      return null;
    }
    const bytes = AES.decrypt(text.toString(), this.guid());
    const data = bytes.toString(UTF8);
    return data;
  }

  enc(text: string) {
    const eText = AES.encrypt(text, this.guid());
    return eText;
  }
}
